define.alias("shared/utils/segment/system-labels", "settings/utils/segment/system-labels");